module.exports = __webpack_public_path__ + "bin/f0b122624e951dfb1b7249f300bd8a5f.png";